var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "preview-wrap", style: {
      transform: 'scale(' + _vm.scale + ')',
      width: _vm.deviceInfo.width + 'px',
      height: _vm.deviceInfo.height + 'px'
    } }, [_c('iframe', { ref: "iframe", staticClass: "preview-frame", style: {
      transform: 'scale(' + _vm.deviceInfo.innerWidth / _vm.deviceInfo.frameWidth + ')',
      marginLeft: (_vm.deviceInfo.width - _vm.iframeWidth) / 2 + 'px',
      marginTop: (_vm.deviceInfo.height - _vm.iframeHeight) / 2 + 'px'
    }, attrs: { "id": "preview-device-iframe", "width": _vm.iframeWidth, "height": _vm.iframeHeight, "src": _vm.src, "frameborder": "0" } }), _vm._v(" "), _c('div', { directives: [{ name: "loading", rawName: "v-loading", value: _vm.loading, expression: "loading" }], staticClass: "preview-layer", class: {
      'preview-landscape': _vm.orientation === 2,
      'preview-layer-rect': _vm.deviceType === 3
    }, style: {
      width: _vm.deviceInfo.innerWidth * 2 + 'px',
      height: _vm.deviceInfo.innerHeight * 2 + 'px',
      marginLeft: (_vm.deviceInfo.width - _vm.deviceInfo.innerWidth * 2) / 2 + 'px',
      marginTop: (_vm.deviceInfo.height - _vm.deviceInfo.innerHeight * 2) / 2 + 'px',
      zIndex: _vm.loading ? 2 : 1
    } }), _vm._v(" "), _c('img', { staticClass: "preview-bg", class: _vm.orientation === 2 && 'preview-landscape', attrs: { "width": _vm.deviceInfo.width, "height": _vm.deviceInfo.height, "src": _vm.deviceInfo.src } })]);
};
var staticRenderFns = [];

export { render, staticRenderFns };